<ng-container *ngIf="isLoading">
  <div class="scroll-content">
    <div class="loading-sec">
      <img class="int-pag-img" src="assets/loading.gif" alt="Loading..." />
      <div>Please wait...</div>
    </div>
  </div>
</ng-container>
